<!--
* UIID: UI-CAAS-COM-113
* UI Name: IMAP
* Modify Date: 2020/06/15
-->
<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4" style="height: 595px; overflow: auto">
        <!-- First Row -->
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.imap') }}
            </font>
            <v-text-field
              v-model="formData.name"
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              :error-messages="formError.name.message"
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
          <!-- // 2021.8.30 203728 SPKA-201 remove partner from communication -->
          <!-- <v-col cols="12" md="4">
            <v-select
              v-model="formData.partner"
              :items="partners"
              :placeholder="$t('lbl.common.conditionSearch.selectPartner')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
          <!-- 203665 2021/03/03
            SPKA-44 Remove Direction on screen Communication 
          -->
          <!-- <v-col cols="12" md="4">
            <v-select
                v-model="formData.direction"
              :items="inouts"
              :placeholder="$t('lbl.common.conditionSearch.selectDirection')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
        </v-row>
        <!-- 2 Row 54px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Server Address</v-label>
            <v-text-field
              v-model="formData.host"
              :rules="[validationUtils.required, validationUtils.max(50)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="8" class="pr-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Security</v-label>
                <v-select
                  v-model="formData.security"
                  :items="securities"
                  :rules="[validationUtils.required]"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
                <v-text-field
                  v-model="formData.port"
                  type="number"
                  :rules="[validationUtils.required, validationUtils.max(5)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--3 Row 40px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>User ID</v-label>
            <v-text-field
              v-model="formData.userid"
              :rules="[validationUtils.required, validationUtils.max(200)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
            <v-text-field
              v-model="formData.password"
              :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="formData.showpassword ? 'text' : 'password'"
              @click:append="formData.showpassword = !formData.showpassword"
              :rules="[validationUtils.required, validationUtils.max(20)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
              @focus="handlePasswordType"
              @blur="handlePasswordType"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="6" class="pr-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.communications.exeInterval') }}</v-label
                >
                <v-text-field
                  v-model="formData.interval"
                  type="number"
                  :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="intervalDefault"
                  :items="intervals"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  return-object
                  class="select-interval"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="12" class="px-4">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.communications.emailFld') }}</v-label
                >
                <v-text-field v-model="formData.path" solo :disabled="!$auth.manage"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="pr-0">
            <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
            <v-text-field
              v-model="formData.maxRetry"
              type="number"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-label
              ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
              >{{ $t('lbl.communications.dataPart') }}</v-label
            >
            <v-select
              v-model="formData.imapPart"
              :items="dataPartList"
              solo
              :menu-props="{ offsetY: true }"
              :rules="[validationUtils.required]"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="12" class="mb-2">
                <v-label>Oauth 2.0</v-label>
                <v-icon v-if="!showOauth" dense class="ml-3 mt-0" @click="processShowOauth(true)">
                  mdi-plus
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="showOauth"
          class="ml-1 mr-1 mb-2 mt-3 edi-identification rest-api-form"
          style="height: auto"
        >
          <v-col cols="12" md="12" class="text-right px-0">
            <v-btn small text icon @click="processShowOauth(false)">
              <icon-svg iconName="close" />
            </v-btn>
          </v-col>
          <v-col cols="12" md="12" class="pl-0 pr-0 pt-3">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Grant Type</v-label>
            <v-select
              v-model="formData.grantType"
              :items="grantTypeList"
              solo
              :menu-props="{ offsetY: true }"
              :disabled="!$auth.manage"
              :rules="[validationUtils.required]"
            ></v-select>
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token URI</v-label>
            <v-text-field
              v-model="formData.accessToken"
              solo
              :menu-props="{ offsetY: true }"
              :disabled="!$auth.manage"
              :rules="[validationUtils.required, validationUtils.max(250)]"
            ></v-text-field>
            <v-row>
              <v-col cols="12" md="2" class="pt-4">
                <v-label>Basic Auth</v-label>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  placeholder="ID"
                  v-model="formData.authId"
                  solo
                  hide-details
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  :rules="[(v) => v.length <= 50 || `Max 50 characters`]"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  placeholder="Password"
                  v-model="formData.authPass"
                  :rules="[(v) => v.length <= 100 || `Max 100 characters`]"
                  :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="formData.showpassword ? 'text' : 'password'"
                  @click:append="formData.showpassword = !formData.showpassword"
                  solo
                  :disabled="!$auth.manage"
                  autocomplete="off"
                  hide-details
                  @focus="handlePasswordType"
                  @blur="handlePasswordType"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2" class="pt-4">
                <v-label>API Key</v-label>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="formData.authKey"
                  solo
                  hide-details
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  :rules="[(v) => v.length <= 10 || `Max 10 characters`]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="formData.authToken"
                  solo
                  hide-details
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  :rules="[(v) => v.length <= 255 || `Max 255 characters`]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ml-0 mr-0 d-block pt-4">
              <v-col lg="11" class="pa-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token Headers</v-label>
              </v-col>
              <v-tooltip top :disabled="tokenHeads.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="1" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern('THEAD')"
                        :disabled="!$auth.manage || tokenHeads.length > maxPattern - 1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form
              ref="tokenHeads"
              class="dialog-content pr-0 mb-2"
              v-on:submit.prevent="doNoThing"
            >
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, index) in tokenHeads"
                :key="item.id"
              >
                <v-col cols="12" md="4" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          :ref="'THEAD_' + item.id"
                          solo
                          hide-details
                          v-model="item.keyHeader"
                          @mouseleave="resetSetPattern('THEAD')"
                          :rules="[validationUtils.required]"
                        ></v-text-field>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="7" class="pa-0 pl-2">
                  <v-text-field
                    :ref="'THEAD_' + item.id + '_' + item.id"
                    solo
                    hide-details
                    v-model="item.valueHeader"
                    :rules="[validationUtils.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                  <v-icon dense @click="removePattern('THEAD', index)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
            <v-row class="ml-0 mr-0 pt-2 d-block">
              <v-col lg="11" class="pa-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token Config</v-label>
              </v-col>
              <v-tooltip top :disabled="tokenConfigs.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="1" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern('TCONF')"
                        :disabled="!$auth.manage || tokenConfigs.length > maxPattern - 1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form
              ref="tokenConfigs"
              class="dialog-content pr-0 mb-2"
              v-on:submit.prevent="doNoThing"
            >
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, index) in tokenConfigs"
                :key="item.id"
              >
                <v-col cols="12" md="4" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          :ref="'TCONF_' + item.id"
                          solo
                          hide-details
                          v-model="item.keyHeader"
                          @mouseleave="resetSetPattern('TCONF', index)"
                          :rules="[validationUtils.required]"
                        ></v-text-field>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="7" class="pa-0 pl-2">
                  <v-text-field
                    :ref="'TCONF_' + item.id + '_' + item.id"
                    solo
                    hide-details
                    v-model="item.valueHeader"
                    :rules="[validationUtils.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                  <v-icon dense @click="removePattern('TCONF', index)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
    >
    </dialogWindow>
  </v-card>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  components: {
    dialogWindow,
    IconSvg,
  },
  props: {
    item: {
      default: Object,
    },
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // prnrList: {
    //   type: Array,
    // },
  },

  data() {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      // 2021.8.30 203728 SPKA-201 remove partner from communication
      // partners: [
      //   {value: 'INT', text: 'INTTRA'},
      //   {value: 'ONE', text: 'ONE'},
      //   {value: 'SO', text: 'SmartLink Platform'},
      //   {value: 'PORTE', text: 'PORTEVER'},
      //   {value: 'FL', text: 'Faircon Line'},
      //   {value: 'ULS', text: 'ULS'},
      //   {value: 'WooW', text: 'WooWon'},
      //   {value: 'IMPEX', text: 'IMPEX'}
      // ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
      dataPartList: [],
      authList: [],
      tokenHeads: [],
      tokenConfigs: [],
      maxPattern: 5,
      grantTypeList: [],
      setPatternHead: new Set(),
      setPatternConfig: new Set(),
      showOauth: false,
      checkDialogInfo: '',
      checkDialogColor: 'warning',
    };
  },
  created() {
    this.getDataPartList();
    this.getAuthTypeList();
    this.getGrantTypeList();
    this.formData = Object.assign({}, this.getInitData(), this.item);
    if (!this.formData.interval) {
      this.formData.interval = '30';
    }
    if (this.formData.password) this.formData.showpassword = false;
    this.loadFormData = Object.assign({}, this.getInitData(), this.item);
    if (this.loadFormData.password) this.loadFormData.showpassword = false;
    if (this.item.intervalType) {
      this.intervalDefault = this.intervals.filter(
        (item) => item.value === this.item.intervalType,
      )[0];
    }
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // this.partners = this.prnrList;

    if (this.formData.grantType) this.showOauth = true;
    let emptyObj = this.formData.tokenHeads;

    if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
      this.tokenHeads = this.convertJsonToArrayObject(this.formData.tokenHeads);
    }

    emptyObj = this.formData.tokenConfigs;
    if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
      this.tokenConfigs = this.convertJsonToArrayObject(this.formData.tokenConfigs);
    }
  },

  watch: {
    item() {
      this.resetFormData();
      this.setFocus();
    },
  },

  methods: {
    doNoThing() {
      console.log('Skip Enter');
    },
    convertArrayObjectToJson(listHttpHeaders) {
      let httpHeadersFormat;
      if (listHttpHeaders.length > 0) {
        httpHeadersFormat = listHttpHeaders.reduce(
          (obj, item) => Object.assign(obj, { [item.keyHeader]: item.valueHeader }),
          {},
        );
      } else {
        httpHeadersFormat = {};
      }
      return httpHeadersFormat;
    },
    convertJsonToArrayObject(httpHeaders) {
      httpHeaders = typeof httpHeaders === 'string' ? JSON.parse(httpHeaders) : httpHeaders;
      let listHttpHeaders = [];
      Object.keys(httpHeaders).map((item, index) => {
        listHttpHeaders.push({
          id: index + 1,
          keyHeader: item,
          valueHeader: httpHeaders[item],
        });
      });
      return listHttpHeaders;
    },
    addPattern(status) {
      let index = 0;
      switch (status) {
        case 'THEAD': {
          index =
            this.tokenHeads.length > 0 ? this.tokenHeads[this.tokenHeads.length - 1].id + 1 : 1;
          this.tokenHeads.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        case 'TCONF': {
          index =
            this.tokenConfigs.length > 0
              ? this.tokenConfigs[this.tokenConfigs.length - 1].id + 1
              : 1;

          this.tokenConfigs.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        default:
          break;
      }
    },
    removePattern(status, index) {
      if (status == 'THEAD') {
        this.tokenHeads.splice(index, 1);
      } else if (status == 'TCONF') {
        this.tokenConfigs.splice(index, 1);
      }
    },
    resetSetPattern(status, index) {
      if (status == 'THEAD') {
        this.setPatternHead.clear();
        for (let i = 0; i < this.tokenHeads.length; i++) {
          if (!this.tokenHeads[i].keyHeader) continue;
          if (this.setPatternHead.has(this.tokenHeads[i].keyHeader)) {
            this.tokenHeads[i].isValidatePattern = true;
          } else {
            this.setPatternHead.add(this.tokenHeads[i].keyHeader);
            this.tokenHeads[i].isValidatePattern = false;
          }
        }
      } else if (status == 'TCONF') {
        this.setPatternConfig.clear();
        for (let i = 0; i < this.tokenConfigs.length; i++) {
          if (!this.tokenConfigs[i].keyHeader) continue;
          if (this.setPatternConfig.has(this.tokenConfigs[i].keyHeader)) {
            this.tokenConfigs[i].isValidatePattern = true;
          } else {
            this.setPatternConfig.add(this.tokenConfigs[i].keyHeader);
            this.tokenConfigs[i].isValidatePattern = false;
          }
        }
      }
    },
    getGrantTypeList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P13' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        list.map((item) => {
          this.grantTypeList.push({ text: item.text, value: item.value });
        });
      });
    },
    getAuthTypeList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P12' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        this.authList.push({ text: 'Unused', value: '' });
        list.map((item) => {
          this.authList.push({ text: item.text, value: item.value });
        });
      });
    },
    getDataPartList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P16' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        list.map((item) => {
          this.dataPartList.push({ text: item.text, value: item.value });
        });
      });
    },
    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },
    async save() {
      let editedData = getEditData(this.formData, this.loadFormData);
      if (this.intervalDefault.value) {
        this.formData.intervalType = this.intervalDefault.value;
        editedData.intervalType = this.intervalDefault.value;
      }
      this.formData.protocol = this.formData.type;
      if (this.showOauth) {
        if (this.tokenHeads.length == 0) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validEmptyThead');
          return -1;
        }
        if (this.tokenConfigs.length == 0) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validEmptyTConfig');
          return -1;
        }
        let indexValidPatternHttpHeaders = this.tokenHeads.findIndex(
          (e) => e.keyHeader === '' || e.valueHeader === '',
        );
        if (indexValidPatternHttpHeaders > -1) {
          let itemPattern = this.tokenHeads[indexValidPatternHttpHeaders];
          this.$refs[
            `THEAD_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
          ][0].focus();
          return -1;
        }

        indexValidPatternHttpHeaders = this.tokenConfigs.findIndex(
          (e) => e.keyHeader === '' || e.valueHeader === '',
        );
        if (indexValidPatternHttpHeaders > -1) {
          let itemPattern = this.tokenConfigs[indexValidPatternHttpHeaders];
          this.$refs[
            `TCONF_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
          ][0].focus();
          return -1;
        }

        let found = this.tokenHeads.find((element) => element.isValidatePattern);
        if (found) {
          this.$refs['THEAD_' + found.id][0].focus();
          return -1;
        }
        found = this.tokenConfigs.find((element) => element.isValidatePattern);
        if (found) {
          this.$refs['TCONF_' + found.id][0].focus();
          return -1;
        }
        this.formData.tokenHeads = this.convertArrayObjectToJson(this.tokenHeads);
        this.formData.tokenConfigs = this.convertArrayObjectToJson(this.tokenConfigs);
        this.formData.authClientID = '';
        this.formData.bearerHeadersList = {};
        this.formData.bearerRespList = {};
      }

      this.formData.authType = '';
      if (this.formData.grantType) this.formData.authType = 'oauth2';

      if (this.formData.action == 'edit') {
        /* 
          2021/01/15 203665 workflow issue 21  send only edit Data to JSON
        */
        editedData.id = this.formData.id;
        if (editedData.name === undefined) {
          editedData.name = this.formData.name;
        }
        editedData.protocol = this.formData.type;
        editedData.imapPart = this.formData.imapPart;

        await this.$store.dispatch('editComm', this.formData);
        await this.sendActivate(this.formData.id, 'COM', editedData);
      } else {
        this.formData.type = 'IMAP';
        await this.$store.dispatch('insertComm', this.formData);
      }
      this.resetFormData();
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        showpassword: true,
        path: '',
        imapPart: '',
        interval: '',
        type: 'IMAP',
        authType: '',
        authId: '',
        authPass: '',
        authKey: '',
        authToken: '',
        accessToken: '',
        authClientID: '',
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != 'showpassword' && prop != 'type') {
    //       if (this.formData[prop].trim() != '') {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      if (this.item.type == 'IMAP') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
      }
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
    processShowOauth(status) {
      this.showOauth = status;
      this.formData.grantType = '';
      this.formData.accessToken = '';
      this.formData.authId = '';
      this.formData.authPass = '';
      this.formData.authKey = '';
      this.formData.authToken = '';
      this.tokenHeads = [];
      this.tokenConfigs = [
        {
          id: 0,
          keyHeader: 'grant_type',
          valueHeader: 'client_credentials',
          isValidatePattern: false,
        },
      ];
    },
  },
};
</script>

<style></style>
